import useExperiment from 'hooks/common/use-experiment';

interface UseTest8753Return {
  /** Variant 1: all filters (sidebar/overlay + hero) are hidden globally */
  hideAllFilters: boolean;
  /** Variant 2: only sidebar/overlay filters are hidden; hero filters remain */
  hideSidebarFilters: boolean;
  /** Loading state of the experiment */
  loading: boolean;
  /** The variant number (0 = control, 1 = all filters hidden, 2 = sidebar filters hidden) */
  variant: number | undefined;
}

/**
 * Hook for A/B Test: Disable filters globally
 * Control group (variant 0): Filters remain as current
 * Variant 1: ALL filters (sidebar/overlay AND hero) are disabled/hidden globally
 * Variant 2: ALL filters EXCEPT hero filters are disabled/hidden globally
 * @see https://petsdeli.atlassian.net/browse/PT-8753
 */
const useTest8753 = (): UseTest8753Return => {
  const { variant, loading } = useExperiment({
    baseEntryId: '4ZqKtmW2vIBVFNhPQhX9LQ',
  });

  return {
    hideAllFilters: variant === 1,
    hideSidebarFilters: variant === 2,
    loading,
    variant,
  };
};

export default useTest8753;
